import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/common/SEOHead";
import HeroSection from "@/components/sections/HeroSection";
import AboutSection from "@/components/sections/AboutSection";
import ServicesSection from "@/components/sections/ServicesSection";
import TrainingSection from "@/components/sections/TrainingSection";
import PartnersSection from "@/components/sections/PartnersSection";
import CTASection from "@/components/sections/CTASection";
import NewsSection from "@/components/sections/NewsSection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="SYNRA — AI & Automation Platform Morocco"
        description="Morocco's leading AI & Automation platform. Youth AI training, business automation with n8n, and a partner program for agencies."
        path="/"
        keywords="AI Morocco, automation, n8n, intelligence artificielle Maroc, الذكاء الاصطناعي"
      />
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <TrainingSection />
        <NewsSection />
        <TestimonialsSection />
        <PartnersSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
